export default __webpack_public_path__ + "static/media/pipe3.cae116f8.jpg";